import _ from 'lodash'
import Backbone from 'backbone'
import EditLabel from 'scoreboard/components/designer/edit-label'

const EditStackLabel = Backbone.View.extend({

	tagName: 'form',

	/**
	 * View for editing stack label for a report
	 *
	 * @param {ReportStack} options.model the model of a Report Stack
	 * @param {ReportModel} options.reportModel the model of the report
	 * @param {ReportTableModel} options.tableModel the model of the table
	 * @param {ReportColumn} options.column the model of one of a column in a stack
	 */
	initialize: function(options = {}) {
		this.options = options

		//make a copy of the column we're editing
		this.column = this.model.findColumn(this.options.column).clone()

		let reportModel = this.options.reportModel
		this.defaultLabel = reportModel.defaultLabel(this.column)

		this.editLabel = new EditLabel({
			el: this.el,
			default: !this.column.attributes.customLabel,
			label: this.column.attributes.label
		})
		this.editLabel.once('done', label => {
			//label will be null if it's using the default label
			let useDefaultLabel = _.isNil(label)
			let stackLabel = useDefaultLabel ? this.defaultLabel : label.trim()
			this.column.set({
				label: stackLabel,
				customLabel: !useDefaultLabel
			})
			this.trigger('done', this.column)
		})
	},

	render: function() {
		this.editLabel.render()
		return this
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editLabel], 'remove')
	}

})

export default EditStackLabel
EditStackLabel.__filename__ = 'reports/common/edit-stack-label.js'
